export default {

    index: {
        features: '功能',
        pricing: '定价',
        about: '关于我们',
        faq: '常见问题',
        title: '人工智能笔记，让思维更清晰',
        subtitle: '将音频、视频和 PDF 即时转换为有组织的笔记。',
        title2: '被 5000 多所大学的学生选择',
        title3: '听听用户对我们产品的评价',
        service: '服务条款',
        privacy: '隐私政策',
        start: '立即使用',
        start2: '免费使用',
        dashboard: '控制面板',
    },
    testimonials: [
        {
            name: "录制实时讲座",
            content1: "",
            content: "我们的工具提供多种语言的实时转录，为口语内容提供实时文本版本。",
            iconurl: require("../assets/images/index/icons/10.png"),
        },
        {
            name: "音频笔记生成",
            content1: "录制或上传音频文件：",
            content: "将您的口语转换为高质量、结构化的笔记。",
            iconurl: require("../assets/images/index/icons/1.png"),
        },
        {
            name: "YouTube 视频笔记生成",
            content1: "添加 YouTube 视频链接：",
            content: "从 YouTube 视频生成组织良好的笔记。",
            iconurl: require("../assets/images/index/icons/2.png"),
        },
        {
            name: "PDF 笔记生成",
            content1: "上传 PDF，包括研究论文、财务报告等：",
            content: "从您的 PDF 文档创建全面的摘要和分析。",
            iconurl: require("../assets/images/index/icons/3.png"),
        },
        {
            name: "测验",
            content1: "根据您的内容源生成测验：",
            content: "通过互动测验增强对关键概念的理解。",
            iconurl: require("../assets/images/index/icons/4.png"),
        },
        {
            name: "闪卡",
            content1: "生成闪卡：",
            content: "将您的笔记转换为闪卡，以有效保留知识。",
            iconurl: require("../assets/images/index/icons/5.png"),
        },
        {
            name: "提问",
            content1: "向您上传的文档提问：",
            content: "通过直接向文档提问获得更深入的见解。",
            iconurl: require("../assets/images/index/icons/6.png"),
        },
        {
            name: "思维导图",
            content1: "",
            content: "通过思维导图可视化和组织复杂信息。",
            iconurl: require("../assets/images/index/icons/7.png"),
        },
        {
            name: "总结报告",
            content1: "从多种类型的文档创建总结报告：",
            content: "通过自动生成的摘要快速掌握文档的要点。",
            iconurl: require("../assets/images/index/icons/8.png"),
        },
        {
            name: "多语言支持",
            content1: "将您的笔记翻译成多种语言：",
            content: "在全球范围内沟通和分享您的知识。",
            iconurl: require("../assets/images/index/icons/9.png"),
        },
        {
            name: "对话式学习",
            content1: "",
            content: "与课程内容展开对话式学习，激发深度思考。",
            iconurl: require("../assets/images/index/icons/12.png"),
        },
    ],
    students: [
        {
            name: "JohnDoe",
            nickname: "JohnDoe",
            schoolImage: require("../assets/images/index/avatar1.jpg"),
            schoolName: "哥伦比亚大学",
            para: "目前真的很喜欢 <i style='color: #EA60FF; font-style: normal;'>@EasyNoteAI</i>。它作为一个个人笔记应用的简单性和速度恰到好处，大部分整理工作都在后台完成。",
        },
        {
            name: "AlexTheGreat",
            nickname: "Alex",
            schoolImage: require("../assets/images/index/avatar2.jpg"),
            schoolName: "哈佛大学",
            para: "我刚收到 <i style='color: #EA60FF; font-style: normal;'>@EasyNoteAI</i> 的邀请，天哪！它设计得很周到，我能看到它将成为我未来的笔记平台。干得漂亮！我很期待看到这个应用的进展。",
        },
        {
            name: "SophieSpark",
            nickname: "spark",
            schoolImage: require("../assets/images/index/avatar3.jpg"),
            schoolName: "麻省理工学院",
            para: "在使用 <i style='color: #EA60FF; font-style: normal;'>@EasyNoteAI</i>，我正在回溯过去一周的播客、书籍、会议、文章等的关键词、细节和片段。到目前为止，它是知识工作者的梦想成真。",
        },
        {
            name: "LiamRocks",
            nickname: "alice",
            schoolImage: require("../assets/images/index/avatar2.jpg"),
            schoolName: "哥伦比亚大学",
            para: "目前真的很喜欢 <i style='color: #EA60FF; font-style: normal;'>@EasyNoteAI</i>。它作为一个个人笔记应用的简单性和速度恰到好处，大部分整理工作都在后台完成。",
        },
        {
            name: "MiaJoy",
            nickname: "Mias",
            schoolImage: require("../assets/images/index/avatar1.jpg"),
            schoolName: "哈佛大学",
            para: "我刚收到 <i style='color: #EA60FF; font-style: normal;'>@EasyNoteAI</i> 的邀请，天哪！它设计得很周到，我能看到它将成为我未来的笔记平台。干得漂亮！我很期待看到这个应用的进展。",
        },
    ],
    students2: [
        {
            name: "EthanHawk",
            nickname: "Ethan",
            schoolImage: require("../assets/images/index/avatar5.jpg"),
            schoolName: "哥伦比亚大学",
            para: "探索 <i style='color: #EA60FF; font-style: normal;'>@EasyNoteAI</i> 让我感到惊喜！它的简洁和高效让笔记变得轻松自如，同时还能自动整理所有内容，非常实用。",
        },
        {
            name: "OliviaBright",
            nickname: "Olivia",
            schoolImage: require("../assets/images/index/avatar6.jpg"),
            schoolName: "哈佛大学",
            para: "使用 <i style='color: #EA60FF; font-style: normal;'>@EasyNoteAI</i> 越久，就越能感受到它的直观和结构合理。它完美结合了极简设计和强大功能，非常适合记录灵感。",
        },
        {
            name: "SophiaRay",
            nickname: "Sophia",
            schoolImage: require("../assets/images/index/avatar7.jpg"),
            schoolName: "麻省理工学院",
            para: "我开始用 <i style='color: #EA60FF; font-style: normal;'>@EasyNoteAI</i> 来整理学习、书籍、研究中的关键信息。它让知识管理变得无比顺畅和有趣。",
        },
        {
            name: "LiamRocks",
            nickname: "Liam",
            schoolImage: require("../assets/images/index/avatar8.jpg"),
            schoolName: "哥伦比亚大学",
            para: "使用 <i style='color: #EA60FF; font-style: normal;'>@EasyNoteAI</i> 的体验非常流畅。这正是我需要的工具，可以帮助我轻松整理思绪，而不用手动费心分类。",
        },
        {
            name: "JamesNova",
            nickname: "James",
            schoolImage: require("../assets/images/index/avatar5.jpg"),
            schoolName: "哈佛大学",
            para: "我已经能预见 <i style='color: #EA60FF; font-style: normal;'>@EasyNoteAI</i> 会成为我的首选笔记工具。它的简洁界面和智能功能让它在众多笔记软件中脱颖而出！",
        },
    ],
    price: {
        h1: "提高您的学习效率高达",
        free: "免费",
        usenow: "立即使用",
        subscribenow: "立即订阅",
        month: "月",
        name0: "入门版",
        name1: "年度版",
        name2: "月度版",
        tooltip: "如果不够的话，您可以轻松购买额外的附加包。",
        content1_1: "<span style='font-weight: bold; color: #a0ff6c;'>每月 2400 分钟直播课程录制 </span>",
        content0: "每月 15 分钟直播课程录制 <br /> 每月 1 小时上传音频和 YouTube/Bilibili <br /> 每月 3 个 PDF 上传 <br /> 每月 10 条聊天消息 <br /> 每月无限制闪卡 <br /> 每月无限制测验题目",
        content1: "每月无限制上传音频和 YouTube/Bilibili <br /> 每月无限制 PDF 上传 <br /> 每月无限制聊天消息 <br /> 每月无限制闪卡 <br /> 每月无限制测验题目",
        content2: "每月无限制上传音频和 YouTube/Bilibili <br /> 每月无限制 PDF 上传 <br /> 每月无限制聊天消息 <br /> 每月无限制闪卡 <br /> 每月无限制测验题目",
        
        // 新增会员套餐弹窗翻译
        upgrade: "升级至高级版",
        improveEfficiency: "提高您的学习效率高达",
        features: "功能特性",
        monthlyPlan: "月度计划",
        yearlyPlan: "年度计划",
        unlimited: "无限制",
        minPerMonth: "分钟/月",
        hourPerMonth: "小时/月",
        perMonth: "个/月",
        liveRecording: "直播课程录制",
        audioUpload: "音频和视频上传",
        documentsUpload: "文档上传",
        chatMessages: "聊天消息",
        flashcards: "闪卡",
        quiz: "测验题",
        subscribe: "立即订阅",
        save: "节省",
        billedYearly: "按年计费",
        billedMonthly: "按月计费",
        termsOfService: "服务条款",
        privacyPolicy: "隐私政策",
        
        // 新增套餐描述
        unlimitedLiveRecord: "无限制直播课程录制",
        unlimitedAudioRecord: "无限制音频和YouTube/Bilibili录制",
        unlimitedDocuments: "无限制文档上传",
        unlimitedChat: "无限制聊天消息",
        unlimitedFlashcards: "无限制闪卡和测验题目"
    },
    about: {
        title: "ZenNyx AI inc.",
        p1: "ZenNyx AI inc 由来自全球领先互联网和人工智能公司的专家团队创立，致力于将 AI 技术与高等教育和科研场景深度融合，帮助学生和科研人员提升课程学习和学术研究的效率。",
        p2: "EasyNoteAI 是 ZenNyx AI inc 面向全球高校学生和科研人员推出的一款重磅 AI 产品，利用 AI 能力快速从课堂、在线视频讲座、文献阅读中提取有价值的信息，输出结构化的课堂笔记、讲座总结、文献综述等。",
        p3: "EasyNoteAI 支持多种语言，让来自全球高校使用不同语言的人们充分享受 AI 技术带来的效率提升。",
        p4: "ZenNyx AI inc 将继续深耕 AI 教育领域，不断探索，服务广大教育用户。",
        p5: "如遇到任何问题，欢迎给我留言或通过 Email 联系我："
    },
    faqItems: [
        {
            question: "录制实时讲座？",
            answer: "实时录制、转录和翻译您的笔记。这一惊艳功能让您在听讲座的同时生成您首选语言的笔记。解放您的双手，再也不会错过任何关键点。"
        },
        {
            question: "支持我的语言吗？",
            answer: "我们提供英语、法语、西班牙语、德语、意大利语、俄语、日语、阿拉伯语、印地语、葡萄牙语、荷兰语、韩语、土耳其语、简体中文和繁体中文的服务。我们还在不断扩展语言支持范围。"
        },
        {
            question: "为什么我无法下载我的音频文件？",
            answer: "如果录制时间约为 2 小时，老旧的电脑或平板可能会因内存不足和浏览器保护机制自动删除录音。建议在录制前关闭不必要的标签和程序，并使用 Chrome 以获得最佳性能。"
        },
        {
            question: "我上传音频时遇到问题？",
            answer: "请确认您的文件符合以下要求：<br>- 文件大小小于 140MB<br>- 文件格式为 MP3、AIFF、WAV、FLAC、AAC、OGG、M4A 或 ALAC。"
        },
        {
            question: "为什么 EasyNoteAI 只录制了部分音频？",
            answer: "作为基于网页的工具，EasyNoteAI 有时可能会因网络条件或系统因素出现问题。我们正在开发一款移动应用，提供更可靠和高效的录制体验。"
        },
        {
            question: "我在使用 YouTube 视频时遇到问题？",
            answer: "请注意，EasyNoteAI 目前不支持 YouTube Shorts、直播、私密视频或超过 3 小时的视频。如果您仍遇到问题，请通过电子邮件或留言板联系我们的支持团队。"
        },
        {
            question: "我可以在手机上使用 EasyNoteAI 吗？",
            answer: "虽然我们目前建议使用电脑，但我们的移动应用正在开发中，很快就会推出。"
        },
        {
            question: "如何从笔记下载思维导图？",
            answer: "将笔记复制为 markdown 格式，粘贴到 <a href='https://markmap.js.org/repl' target='_blank' style='color: #fff; text-decoration: underline; font-weight: bold;'>https://markmap.js.org/repl</a>，即可编辑并保存思维导图。"
        },
        {
            question: "为什么我无法下载 PDF？",
            answer: "如果您现在无法下载 PDF，请尝试以下方法：<br>1. 清除浏览器缓存和 cookie。<br>2. 尝试使用隐身模式。<br>3. 禁用所有浏览器扩展。<br>4. 将浏览器更新至最新版本。<br>5. 尝试使用其他浏览器，如 Chrome。"
        }
    ],
    faqItems2: [
        {
            question: "通过我们的年度计划获得最佳价值！",
            answer: "我们提供多种订阅计划以满足您的需求。升级到年度计划，与按月计费相比可节省 70%。"
        },
        {
            question: "什么是免费计划？",
            answer: "我们的免费计划让您试用所有 EasyNoteAI 功能，但使用次数有限。升级到订阅计划即可享受无限使用。"
        },
        {
            question: "如何暂停我的订阅？",
            answer: "我们目前不提供暂停功能。不过，您可以随时取消订阅。"
        },
        {
            question: "如何结束或取消订阅？",
            answer: "如果您通过我们的网站订阅，请按照以下步骤操作：<br><span style='font-size: 14px;' > 1. 前往“设置”</span><br><span style = 'font-size: 14px;'>2. 点击“账单门户”</span><br><span style = 'font-size: 14px;'>3. 输入您的注册邮箱并提交</span> <br><span style='font-size: 14px;'>4. 您将收到一封电子邮件并按照说明进行操作</span>"
        }
    ],
    faqItems3: [
        {
            question: "支持我的语言吗？",
            answer: "我们提供英语、法语、西班牙语、德语、意大利语、俄语、日语、阿拉伯语、印地语、葡萄牙语、荷兰语、韩语、土耳其语、简体中文和繁体中文的服务。我们还在不断扩展语言支持范围。"
        },
        {
            question: "如何报告问题：",
            // answer: "",
            answer1: "电子邮件：",
            answer2: "内部消息：",
            answer22: "通过支持页面发送消息",
            answer3: "实时聊天：",
            answer33: "通过聊天窗口与我们的支持团队交流"
        },
    ],
    faqItemstitle0: "最受欢迎",
    faqItemstitle1: "录制与笔记",
    faqItemstitle2: "订阅",
    faqItemstitle11: "最受欢迎的问题",
    faqItemstitle22: "录制与笔记常见问题",
    faqItemstitle33: "订阅与支付常见问题",
    privacy: "<h1>隐私政策</h1><section><h2>我们对隐私的承诺</h2><p>在EasyNoteAI，我们优先考虑用户的隐私。我们的隐私和信息使用政策清楚地说明了我们如何处理个人信息。我们的目标是仅收集提供服务所需的最基本信息，同时保护您的个人详细信息。</p></section><section><h2>最少信息收集</h2><p>我们将数据收集限制在最低限度。您的私人信息在EasyNoteAI生态系统中保持机密，不会被外部实体获取。我们完全避免使用第三方cookie，并确保使用的任何第一方cookie严格非侵入性，不存储个人信息。</p></section><section><h2>用户信息管理</h2><p>我们要求的个人信息严格限定为您在注册时提供的内容。我们认识到每个用户数据的独特性，并分别维护这些数据。用户在使用我们的服务前有机会审查其信息，并保留随时通过服务设置访问这些数据的权利。</p></section><section><h2>什么是“个人信息”？</h2><p>个人信息涉及可能导致您身份识别的详细信息，例如：</p><ul><li>姓名</li><li>地址</li><li>电子邮件地址</li><li>电话号码</li></ul></section><section><h2>EasyNoteAI收集哪些信息？</h2><h3>我们的理念</h3><p>EasyNoteAI尊重提供优质服务与维护您隐私之间的微妙平衡。我们旨在仅收集提供卓越服务所必需的个人信息。</p><h3>我们收集的信息类型</h3><p>EasyNoteAI收集的个人信息性质根据您与我们平台的互动而有所不同：</p><ul><li><strong>账户信息：</strong>包括EasyNoteAI用户名、电子邮件和账户详情。</li><li><strong>联系信息：</strong>您的姓名、电子邮件、实际地址和电话号码。</li><li><strong>支付和交易信息：</strong>有关账单、支付方式和交易历史的详细信息。</li><li><strong>欺诈预防信息：</strong>用于检测和阻止欺诈活动。</li><li><strong>使用信息：</strong>关于您如何使用我们服务的数据、性能指标和诊断信息。</li><li><strong>其他提供的信息：</strong>您向我们传达的任何其他详细信息，包括客户支持互动。</li></ul><p class=\"note\">注意：提供个人信息并非强制性的，但缺少这些信息可能会影响我们为您提供某些服务或回应您的询问的能力。</p></section><section><h2>个人信息的使用</h2><p>EasyNoteAI利用个人信息来：</p><ul><li><strong>服务运营：</strong>改进我们的服务并处理您的交易。</li><li><strong>通信：</strong>管理关于您的账户和我们服务的通信，通知您政策变更，并收集反馈。</li><li><strong>安全和欺诈预防：</strong>保护所有利益相关者并防止欺诈。</li><li><strong>遵守法律：</strong>满足法律要求并回应政府请求。</li></ul><p class=\"note\">请记住，关键通信无法选择退出，因为它们对您与EasyNoteAI的互动至关重要。</p></section><section><h2>个性化</h2><p>EasyNoteAI旨在根据您的活动定制您的体验。隐私详情将在首次使用时以及您的EasyNoteAI账户设置中提供。</p></section><section><h2>信息保留</h2><p>我们会保留个人信息，只要是为了履行其收集目的所需的时间，同时遵守我们的隐私政策和法律要求。</p></section><section><h2>分享个人信息</h2><p>EasyNoteAI可能会与以下对象分享您的信息：</p><ul><li><strong>附属公司和服务提供商：</strong>代表我们执行任务，同时确保遵守我们的隐私政策。</li><li><strong>合作伙伴：</strong>经您同意，与第三方合作提供联合服务。</li><li><strong>其他：</strong>为了回应法律程序或出于安全和公共重要性考虑。</li></ul><p>我们承诺，未经您的明确同意，绝不会将您的个人信息与第三方分享用于其独立营销。</p></section><section><h2>保护您的信息</h2><p>EasyNoteAI致力于采用强大的安全实践，结合物理、技术和行政措施，以保护您的个人信息。</p></section><section><h2>EasyNoteAI的cookie及其他技术</h2><p>EasyNoteAI的数字生态系统——涵盖我们的网站、在线服务和交互式应用程序——避免使用第三方“cookie”及类似追踪技术，如网络信标。然而，为了提升功能和用户体验，我们可能会使用以下技术：</p><ul><li><strong>通信cookie：</strong>这些cookie促进了EasyNoteAI网络中数据的流动，有助于检测和纠正错误。</li><li><strong>必要cookie：</strong>用于提供您请求的特定功能或服务，对于我们网站的正确呈现和运行至关重要，包括语言和交易验证。</li><li><strong>分析cookie：</strong>用于了解访问者如何与我们的服务互动，帮助我们评估和改进其效果。</li></ul><p><strong>选择退出：</strong>如果您希望退出cookie使用，EasyNoteAI提供通过浏览器隐私设置选择“阻止所有cookie”的选项来禁用cookie。请注意，禁用cookie可能会影响您使用EasyNoteAI网站某些功能的能力。</p><p><strong>超越cookie：</strong></p><ul><li>我们可能会在电子邮件通信中嵌入“点击链接URL”，以将您引导至EasyNoteAI网站的相关内容。此过程涉及在单独的服务器上短暂停留，使我们能够评估参与度。不愿被追踪？只需避免点击我们电子邮件中的链接即可。</li><li>从这些cookie和技术中收集的信息通常是非个人性的。然而，如果IP地址或类似标识符被当地法律视为个人信息，我们会对这些标识符应用相同级别的隐私保护。</li><li>在某些情况下，通过这些方法收集的非个人信息可能会与我们持有的其他个人数据合并。在这种情况下，合并后的数据集将根据我们的隐私政策被视为并受到保护为个人信息。</li></ul><p><strong>广告实践：</strong></p><ul><li>EasyNoteAI自有平台在您使用产品期间显示的任何广告都设计为尊重您的隐私——它们不会利用或传播您的个人信息。</li></ul></section>",
    terms: "<h1>服务条款</h1><section><h2>录音政策</h2><p>EasyNoteAI强调遵守有关录音和分享教育内容的法律和机构规定的重要性。我们要求用户严格遵守以下准则：</p><section><h3>遵守学校或大学政策</h3><p>用户不得录音或上传任何违反其学校、学院、工作场所、大学或导师所制定政策的材料。每个用户有责任充分了解并遵守其机构关于录音和分发教育材料及讲座的规定。</p><h3>遵守版权法</h3><p>除非获得版权持有人的明确许可，用户不得录音或上传受版权保护的材料。这包括文本、图片、图形以及任何其他形式的受版权保护的材料。</p><h3>尊重隐私和敏感对话</h3><p>用户禁止录音或分享任何会违反美国隐私法律和规定的敏感对话或信息。这包括私人讨论、机密通信或任何其他受法律保护免于未经授权录音和传播的交流。</p></section><p>EasyNoteAI不支持且不对录音或上传任何受教育机构政策、版权法或美国隐私法禁止的内容承担责任。用户需完全负责确保其在平台上的行为完全遵守这些法律和政策。</p><p>通过使用我们的平台，用户同意对因未经授权录音或分享材料而引发的任何法律行动赔偿EasyNoteAI。我们相信用户会尊重管理教育内容和私人通信的知识产权、隐私和政策限制。</p></section><section><h2>查看EasyNoteAI内容的许可</h2><p>在您遵守这些使用条款的前提下，EasyNoteAI授予您有限的、个人的、非独占的、非商业的、可撤销的、不可转让的许可，以访问和使用EasyNoteAI提供的内容（“EasyNoteAI内容”）。服务的使用严格仅限于您个人的、非商业的教育目的。</p><p>您同意不通过任何自动化手段（包括但不限于脚本、机器人、蜘蛛、爬虫或抓取工具）访问、复制、录音或获取服务中的内容或信息，或使用任何数据挖掘技术或流程来框架、掩盖、提取数据或以其他方式从EasyNoteAI内容中获取材料（除非通过标准搜索引擎或互联网浏览器使用），除非您与EasyNoteAI签订了书面协议明确允许这样做。</p><p>如果您购买了订阅或许可以访问任何EasyNoteAI内容，该订阅或许可仅限您个人使用，不得与他人共享。EasyNoteAI可能会对您访问EasyNoteAI内容的范围设定合理限制，包括时间、访问材料数量或用于访问内容的设备数量的限制，以防止未经授权使用或第三方访问内容。</p></section><section><h2>履行政策</h2><p>在EasyNoteAI，我们致力于为客户提供有关退款、交付、退货和取消的清晰透明政策。我们的目标是通过公平和清晰建立信任，确保所有用户获得无缝体验。</p><section><h3>退款政策</h3><p>我们支持我们软件服务的质量。然而，我们理解可能会出现问题。我们的政策仅在客户遇到我们无法解决的技术故障或问题时允许退款。请在购买后30天内联系我们的支持团队，详细说明您遇到的问题以请求退款。</p><h3>取消政策</h3><p>我们的服务订阅可随时通过我们网站设置页面上的账单门户取消。取消后，您将保留对高级功能的访问权限，直到当前账单周期结束。此周期结束后，高级功能的访问权限将被撤销。</p></section><h2>EasyNoteAI内容和版权政策</h2><p>在EasyNoteAI，我们尊重所有个人（包括教职员工和教育机构）的知识产权。我们的平台为学术成长提供了一个协作空间，但这个空间必须在法律和道德标准的范围内运作，特别是在版权法方面。我们要求所有用户遵守版权法并尊重内容创作者的知识产权。</p></section><section><h2>禁止行为</h2><p>在EasyNoteAI上明确禁止以下行为：</p><ul><li><strong>未经许可上传受版权保护的内容：</strong>EasyNoteAI不支持或鼓励未经适当授权上传、分享或分发受版权保护的材料。</li><li><strong>未经许可上传教职员工生成的内容：</strong>教职员工对其教学材料拥有版权。未经版权持有人的明确同意，学生不得上传教职员工生成的内容，例如讲义、幻灯片或其他教育资源。</li><li><strong>分享录音或逐字记录：</strong>EasyNoteAI严格禁止在我们的平台上分享直接讲座录音或逐字记录。事实上，我们不存储讲座记录，也不为用户提供访问权限。此措施旨在尊重教育者的知识产权和课堂环境的隐私。</li><li><strong>违反大学政策：</strong>用户必须确保上传到其大学社区在EasyNoteAI上的任何内容符合所有相关大学政策。这包括但不限于禁止未经授权录音、分享材料和违反学术诚信的政策。如果某行为在用户所在地合法但违反大学规定，则不得在我们的平台上执行或分享。</li></ul><p>提供给EasyNoteAI用户的教育内容以简洁、AI生成的概述形式交付，以确保有效学习，同时尊重版权规范。</p></section><section><ul><li>您的联系信息。</li><li>声称被侵权的版权作品的描述。</li><li>材料在我们平台上位置的描述。</li><li>真诚相信争议使用未经授权的声明。</li><li>您的电子或物理签名。</li></ul></section><section><h2>责任和后果</h2><p>在收到有效的版权侵权通知后，EasyNoteAI将迅速采取行动，移除或禁用对声称侵权的材料的访问。</p><p>违反我们的政策可能导致以下后果，包括：</p><ul><li>移除侵权内容。</li><li>暂停用户对我们服务的访问。</li><li>终止用户账户。</li><li>对用户提起版权侵权的法律诉讼。</li></ul></section><section><h2>荣誉守则</h2><p>我们坚信学术诚信在学习过程中的重要作用，并致力于维护其完整性。</p><p>我们的平台通过提供AI生成的笔记、抽认卡和测验等创新工具来促进学习。这些功能仅旨在补充和强化个人学习体验，而非替代个人学习和反思所带来的努力和理解。</p><p>我们的政策严格禁止将服务用于任何形式的学术不诚实行为。这包括但不限于分享测试内容或其他评估材料。从事此类行为，例如索取或分发考试答案，或剽窃内容冒充自己的作品，从根本上违背了我们秉持的教育价值观。</p><p>滥用我们的平台以促进作弊、欺诈或学术不诚实是被严格禁止的。如果我们发现服务被不当使用，我们将采取果断行动，以维护我们平台和学习社区的完整性，这可能包括移除侵权材料、停用涉及此类不当行为的用户账户，以及与学术机构合作。我们保留与大学和学术机构分享任何公开发布的内容及发布该内容的个人的账户信息的权利。</p><p>作为学生，我们理解学术带来的繁重日程和压力。然而，通过同学和同事的警示故事，我们也意识到违反学术诚信守则的捷径并不能带来真正的优势。简单地复制答案或分享未经阐述的解决方案可能有助于完成任务，但这削弱了教育的真正目标——学习和理解。这是我们在服务中坚定维护的立场。</p></section>",
}